import { ChangeDetectorRef, Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeReviewDetailsComponent } from 'app/modules/change-review/components/change-review-details/change-review-details.component';
import { AppIcons } from 'app/modules/shared/app.icons';
import { AppSettings } from 'app/modules/shared/app.settings';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { MITableComponent } from 'app/modules/shared/components/mi-table/mi-table.component';
import { ModuleHeaderComponent } from 'app/modules/shared/components/module-header/module-header.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { Country } from 'app/modules/shared/models/country';
import { EntityCountsResponse, EntityList } from 'app/modules/shared/models/entity.models';
import { Language } from 'app/modules/shared/models/language';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { ListResponse } from 'app/modules/shared/models/listResponse.models';
import { DownloadService } from 'app/modules/shared/services/download.service';

@Component({
  selector: 'app-invoices',
  standalone: true,
  imports: [BreadcrumbModule, ModuleHeaderComponent, TabViewModule, TranslateModule, MITableComponent, MITableComponent, AccessProviderDirective, ChangeReviewDetailsComponent],
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.scss'
})
export class InvoicesComponent implements OnInit {

  @ViewChild(MITableComponent) tableRef: MITableComponent;
  routePath: MenuItem[] = [];
  showImportExportBtn: boolean = false;
  miIcons = AppIcons;
  activeIndex: number = 0;
  isEntity: boolean = false;
  uniqueId: string = 'invoice_grid';
  filterList;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels = {};
  filterAttributeLabels = {};
  listColumns: any;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  deleteProductMsg: string;
  deleteProductHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: any[];
  isReady: boolean = false;
  attributeData: any;
  data;
  rowItems: MenuItem[] | undefined;
  filterAvailableColumns = [];
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader;
  reviewHeader: any;
  btnUpdate: any;
  entityCreatedAtAttributeId;
  regionGeofences: any = [];
  zoneIds: any = [];
  productStatusAttributeId: string;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: "COMPLETED",
    viewCode: AppSettings.VIEW_CODE.INVOICE_VIEW
  };
  isLoading = true;

  constructor(private invoiceService: EntityService,
    private cs: CommonBindingDataService, private confirmationService: ConfirmationService,
    private router: Router, private messageService: MessageService, private actRoute: ActivatedRoute,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService, private permissionAccessService: PermissionAccessService,
    private cd: ChangeDetectorRef, private loaderService: LoaderService, private downloadService: DownloadService
  ) { }



  ngOnInit() {
    this.initializeLabels();
    this.initializeColumn();
    this.initializeOtherVariablesAndAPI();
    this.getData();
  }

  initializeLabels() {
    this.routePath = [{ label: this.cs.getLabel('invoices.lbl_header'), routerLink: 'invoices' }];
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.entityData.defaultSortType = AppSettings.DESC_SORT_ORDER
  }

  initializeColumn() {
    this.allColumns = [
      {
        "attributeCode": "orderId",
        "attributeIndex": 0,
        "field": "orderId",
        "header": this.cs.getLabel('invoices.lbl_id'),
        "isSortable": true
      },
      {
        "attributeCode": "protocolName",
        "attributeIndex": 1,
        "field": "protocolName",
        "header": this.cs.getLabel('invoices.lbl_protocol_name'),
      },
      {
        "attributeCode": "date",
        "attributeIndex": 2,
        "field": "date",
        "header": this.cs.getLabel('invoices.lbl_date'),
      },
      {
        "attributeCode": "invoiceNumber",
        "attributeIndex": 3,
        "field": "invoiceNumber",
        "header": this.cs.getLabel('invoices.lbl_invoice'),
      },
      {
        "attributeCode": "invoiceDownload",
        "attributeIndex": 4,
        "field": "invoiceDownload",
      },
    ];
  }

  initializeOtherVariablesAndAPI() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView()
    })
  }

  getTableView() {
    this.isLoading = false;
    this.searchEntity();
    this.filterAvailableColumns = _.clone(this.allColumns);
    this.isEntity = false;
  }

  onSortData(sortColumnDetails) {
    if (sortColumnDetails?.attributeCode === 'orderId') {
      this.entityData.defaultSortColumn = '1001';
    }
    this.entityData.defaultSortType = (sortColumnDetails.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }

  searchEntity() {
    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.loaderService.hide();
    this.invoiceService.searchEntity(AppSettings.ENTITY_CODE.ORDER, this.entityData, false).subscribe((res: ListResponse) => {
      this.listColumns = res?.data[0]?.values;
      this.pagination = res?.pagination;
      this.totalRecords = res?.count;
      this.tableData = res.data.map((data: any) => {
        const protocol = data.relatedData?.find((item: any) => item.entityCode === 'protocol');
        const orderNumber = data.values?.order_number || '--';
        const invoiceNumber = orderNumber.replace(/^CTC/, 'INV');
        return {
          id: data.id,
          orderId: orderNumber,
          date: new Date(data.values?.entity_created_at).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          }),
          protocolName: protocol?.values?.protocol_name || '--',
          invoiceNumber: invoiceNumber || '--',
        };
      });

      this.loaderService.hide();
    })
  }

  onClickInvoiceDownload(event) {
    this.exportSingleOrder(event.id);
  }

  exportSingleOrder(orderId: string) {
    this.loaderService.show();
    this.invoiceService.exportSingleOrder(AppSettings.ENTITY_CODE.ORDER, orderId).subscribe({
      next: (res) => {
        this.loaderService.hide();
        if (res) {
          try {
            this.downloadService.downloadPdf(res, 'order_invoice');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.cs.getLabel('order.download_successful')
            });
          } catch (error) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: this.cs.getLabel('order.download_failed')
            });
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: this.cs.getLabel('order.invalid_response')
          });
        }
      },
      error: () => {
        this.loaderService.hide();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.cs.getLabel('order.download_failed')
        });
      }
    });
  }

  setCurrentRowData(event) {
    this.currentRow = event;
  }

  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
  }


}
